// extracted by mini-css-extract-plugin
export default {"trustedShopsContainer":"trustedShopsContainer--VdCO5","trustmark":"trustmark--euJk0"};